import { Page, RecentActivity, Link } from '@/components';
import HistoricTabs from './HistoricTabs';
import { useCallback } from 'react';
import { Flex, WalletAddress } from '@blockanalitica/ui';

export type ActivityEvent = {
  datetime: string;
  tx_hash: string;
  block_number: string;
  order_index: string;
  wallet_address: string;
  event: string;
  underlying_address: string;
  underlying_symbol: string;
  amount: string;
  amount_usd: string;
};

export default function OverallActivityPage() {
  const contentFn = useCallback(
    (item: ActivityEvent) => (
      <Flex gap="s" alignItems="center">
        {item.event} {item.underlying_symbol}
        <Flex color="muted" gap="2xs">
          Wallet:
          <Link to={`/wallets/${item.wallet_address}`} relative="path">
            <WalletAddress
              address={item.wallet_address}
              options={{ showBlockie: false }}
            />
          </Link>
        </Flex>
      </Flex>
    ),
    []
  );

  return (
    <Page title="Activity">
      <HistoricTabs />

      <RecentActivity<ActivityEvent>
        activityAPIUrl="/overall/events/"
        activityContentFn={contentFn}
        heatmapAPIUrl="/overall/activity/"
        linkTo="events"
      />
    </Page>
  );
}
